Pixlee.module('Utilities', function(Utilities, App, Backbone, Marionette, $) {
    var _this = this, API, _API, successCallback;

    _this.fingerprint = "0";

    API = {
        getCookie: function(cname) {
            return this._getCookieHelper(cname) || this._getCookieHelper(cname + '_legacy');
        },

        _getCookieHelper: function(cname) {
          var name = cname + "=";
          var ca = document.cookie.split(';');
          for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        },
        addKeenData: function(obj) {
            var addons = [];

            addons.push({
                name: 'keen:ip_to_geo',
                input: {
                    ip: 'ip_address'
                },
                output: 'ip_geo_info'
            });
            obj.ip_address = gon.remote_ip;

            addons.push({
                name: 'keen:ua_parser',
                input: {
                    ua_string: 'user_agent'
                },
                output: 'parsed_user_agent'
            });
            obj.user_agent = navigator.userAgent;

            addons.push({
                name: 'keen:url_parser',
                input: {
                    url: 'page_url'
                },
                output: 'parsed_page_url'
            });
            obj.page_url = document.location.href;

            addons.push({
                name: 'keen:referrer_parser',
                input: {
                    referrer_url: 'referrer_url',
                    page_url: 'page_url'
                },
                output: 'referrer_info'
            });
            obj.referrer_url = document.referrer;
            obj.page_url = document.location.href;

            obj.keen = {
                addons: addons
            };
        },
        trackAnalytics: function(ev, props) {
            var _this = this;
            if (!_this.KeenClient && typeof Keen != 'undefined') {
                Keen.ready(function() {
                    _this.KeenClient = new Keen({
                        projectId: keen_project_id,
                        writeKey: keen_write_key,
                        host: gon.global.env.startsWith('staging') ? 'tinyrick.stag.pixlee.io' : 'tinyrick.pixlee.com'
                    });
                    _this.addKeenData(props);
                    _this.KeenClient.recordEvent(ev, props);
                });
            } else {
                _this.addKeenData(props);
                _this.KeenClient.recordEvent(ev, props);
            }
        },
        facebookLogin: function(isPhoto) {
            var route;
            if (isPhoto) {
                route = _API.photos_social_login_path('facebook', false, _this.fingerprint);
            } else {
                route = _API.social_login_path('facebook', false, _this.fingerprint);
            }
            _API.popupwindow(route, 'Facebook Login', 1000, 600);
        },
        googlePhotosLogin: function(isPhoto) {
            var route = _API.photos_social_login_path('google', false, _this.fingerprint);
            _API.popupwindow(route, 'Google Login', 1000, 600);
        },
        twitterLogin: function(isPhoto) {
            var route;
            if (isPhoto) {
                route = _API.photos_social_login_path('twitter', false, _this.fingerprint);
            } else {
                route = _API.social_login_path('twitter', false, _this.fingerprint);
            }
            _API.popupwindow(route, 'Twitter Login', 1000, 600);
        },
        tumblrLogin: function(isPhoto) {
            var route;
            if (isPhoto) {
                route = _API.photos_social_login_path('tumblr', false, _this.fingerprint);
            } else {
                route = _API.social_login_path('tumblr', false, _this.fingerprint);
            }
            _API.popupwindow(route, 'Tumblr Login', 1000, 600);
        },
        facebookLogout: function(options) {
            _API.logoutSocial('facebook', options);
        },
        twitterLogout: function(options) {
            _API.logoutSocial('twitter', options);
        },
        tumblrLogout: function(options) {
            _API.logoutSocial('tumblr', options);
        },
        facebookLoginWidget: function() {
            var route = Routes.social_login_path('facebook', true, _this.fingerprint);
            _API.popupwindow(route, 'Facebook Login', 1000, 600);
        },
        twitterLoginWidget: function() {
            var route = Routes.social_login_path('twitter', true, _this.fingerprint);
            _API.popupwindow(route, 'Twitter Login', 1000, 600);
        },
        tumblrLoginWidget: function() {
            var route = Routes.social_login_path('tumblr', true, _this.fingerprint);
            _API.popupwindow(route, 'Tumblr Login', 1000, 600);
        },
        handlePinterestShare: function(model) {
            var title = _API.getTitle(model);
            title = App.request('decode:utf8', title);
            _API.popupwindow('https://pinterest.com/pin/create/button/?media=' + App.request('encode:utf8', App.request('get:photo:tumbnail', model)) + '&description=' + App.request('encode:utf8', title), 'Share on pinterest', 750, 302);
            this.trackAnalytics('shared to social platform', {
                category: "social platforms",
                moduleName: _this.moduleName,
                url: window.location.href,
                platform: "pinterest",
                account_id: gon.current_account.id,
                parentURL: gon.parentURL,
                distinct_user_hash: gon.distinct_user_hash,
                fingerprint: gon.fingerprint
            });
        },
        handleTwitterShare: function(model) {
            var title = _API.getTitle(model);
            title = App.request('decode:utf8', title);
            _API.popupwindow('https://twitter.com/intent/tweet?text=' + App.request('encode:utf8', title) + ' ' + '&url=' + App.request('encode:utf8', App.request('get:photo:tumbnail', model)), 'Share on Twitter', 600, 255);
            this.trackAnalytics('shared to social platform', {
                category: "social platforms",
                moduleName: _this.moduleName,
                url: window.location.href,
                platform: "twitter",
                account_id: gon.current_account.id,
                parentURL: gon.parentURL,
                distinct_user_hash: gon.distinct_user_hash,
                fingerprint: gon.fingerprint
            });
        },
        handleFacebookShare: function(model, to) {
            var title = _API.getTitle(model);
            var obj = {
                method: 'feed',
                picture: App.request('get:photo:tumbnail', model),
                description: App.request('decode:utf8', title),
                display: 'popup'
            };

            if (!_.isFalsy(to)) {
                obj.to = to;
                obj.from = to;
            }

            function callback(response) {
                //reportSocialInteraction('facebook');
                _this.trackAnalytics('shared to social platform', {
                    category: "social platforms",
                    moduleName: _this.moduleName,
                    url: window.location.href,
                    platform: "facebook",
                    account_id: gon.current_account.id,
                    parentURL: gon.parentURL,
                    distinct_user_hash: gon.distinct_user_hash,
                    fingerprint: gon.fingerprint
                });
            }
            FB.ui(obj, callback);
        },
        handleTumblrShare: function(model) {
            var title = _API.getTitle(model);
            title = App.request('decode:utf8', title);
            _API.popupwindow('https://www.tumblr.com/share/photo?source=' + App.request('encode:utf8', App.request('get:photo:tumbnail', model)) + '&caption=' + App.request('encode:utf8', title), 'Share on Tumblr', 450, 428);
            this.trackAnalytics('shared to social platform', {
                category: "social platforms",
                moduleName: _this.moduleName,
                url: window.location.href,
                platform: "tumblr",
                account_id: gon.current_account.id,
                parentURL: gon.parentURL,
                distinct_user_hash: gon.distinct_user_hash,
                fingerprint: gon.fingerprint
            });
        }
    };

    //internal Functions
    _API = {
        social_login_path: function(social_platform, widget, finger_print) {
            var config = App.config.toJSON();
            return config.pixlee_backend_server + 'auth/' + social_platform + '?widget=' + widget + '&state=' + finger_print;
        },
        photos_social_login_path: function(social_platform, widget, finger_print) {
            var config = App.config.toJSON();
            return '/auth/' + social_platform + '?widget=' + widget + '&state=' + finger_print;
        },
        popupwindow: function(url, title, w, h) {
            // Fixes dual-screen position                       Most browsers      Firefox
            var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
            var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

            var left = ((screen.width / 2) - (w / 2)) + dualScreenLeft;
            var top = ((screen.height / 2) - (h / 2)) + dualScreenTop;
            var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

            //https://bugs.chromium.org/p/chromium/issues/detail?id=630770 is preventing the child popup from communicating with
            //this main window, so we use localstorage to pass along the info. we watch for it to "close" to finish auth
            var watchPopupClose = setInterval(function() {
                if (newWindow.closed) {
                    var socialProfile = gon.social_profile;

                    if (_.isFalsy(socialProfile) && !_.isFalsy(window.localStorage)) {
                        try {
                            socialProfile = JSON.parse(localStorage.getItem('social_profile'));
                        } catch (evt) {
                            if (window.pixSentry) {
                                window.pixSentry.captureMessage('Failed to parse social_profile data from localstorage', {
                                    level: 'warning',
                                    extra: {
                                        type: typeof evt.data,
                                        eventData: evt.data
                                    }
                                });
                            }
                        }
                    }

                    if (!_.isFalsy(socialProfile)) {
                        App.commands.execute('photo:social:login:success', socialProfile);
                        localStorage.removeItem('social_profile');
                        clearTimeout(watchPopupClose);
                    }
                }
            }, 1000);

            // Puts focus on the newWindow
            if (window.focus) {
                newWindow.focus();
            }
        },
        getTitle: function(model, noEncode) {
            if (!_.isFalsy(model.get('title'))) {
                return model.attributes.title;
            }
            if (!_.isFalsy(model.get('album_title'))) {
                return model.attributes.album_title;
            }
            if (!_.isFalsy(model.get('photo_title'))) {
                return model.attributes.photo_title;
            }
            return false;
        },
        getFacebookAlbums: function(access_token, callback, nextUrl) {
            var albums = [];
            var url = nextUrl ? '/me/albums?fields=count,name&after=' + nextUrl : '/me/albums?fields=count,name';
            FB.api(url, 'get', {
                access_token: access_token
            }, function(response) {
                var perPage = 25;
                var pagination = {
                    page: 1,
                    nextUrl: null,
                    next: false
                };
                for (var i = 0; i < response.data.length; i++) {
                    if(response.data[i].count){
                        var album = response.data[i];
                        album.photo_url = 'https://graph.facebook.com/' + album.id + '/picture?type=album&access_token=' + access_token;
                        albums.push(album);
                    }
                }
                if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.data.length >= perPage) {
                    pagination.next = true;
                    pagination.nextUrl = response.paging.cursors.after;
                }
                if (_.isFalsy(nextUrl)) {
                    albums.push({
                        name: "Tagged Videos",
                        photo_url: ""
                    });
                    albums.push({
                        name: "Uploaded Videos",
                        photo_url: ""
                    });
                }
                callback(albums, pagination);
            });
        },
        logoutSocial: function(social, options) {
            $.ajax({
                url: Routes.social_logout_path(social),
                dataType: 'json',
                success: function(response) {
                    if (response && options.success) {
                        API.trackAnalytics('logout social platform', {
                            category: "social platforms",
                            moduleName: _this.moduleName,
                            url: window.location.href,
                            platform: social,
                            account_id: gon.current_account.id,
                            parentURL: gon.parentURL,
                            distinct_user_hash: gon.distinct_user_hash,
                            fingerprint: gon.fingerprint
                        });
                    }
                }
            });
        }
    };
    App.commands.setHandlers({
        'facebook:login': function(success) {
            successCallback = success;
            API.facebookLogin();
        },
        'twitter:login': function(success) {
            successCallback = success;
            API.twitterLogin();
        },
        'tumblr:login': function(success) {
            successCallback = success;
            API.tumblrLogin();
        },
        'facebook:login:photos': function(success) {
            successCallback = success;
            API.facebookLogin(true);
        },
        'google:login:photos': function(success) {
            successCallback = success;
            API.googlePhotosLogin(true);
        },
        'twitter:login:photos': function(success) {
            successCallback = success;
            API.twitterLogin(true);
        },
        'tumblr:login:photos': function(success) {
            successCallback = success;
            API.tumblrLogin(true);
        },
        'facebook:logout': function(options) {
            API.facebookLogout(options);
        },
        'twitter:logout': function(options) {
            API.twitterLogout(options);
        },
        'tumblr:logout': function(options) {
            API.tumblrLogout(options);
        },
        'facebook:login:widget': function(success) {
            successCallback = success;
            API.facebookLoginWidget();
        },
        'twitter:login:widget': function(success) {
            successCallback = success;
            API.twitterLoginWidget();
        },
        'tumblr:login:widget': function(success) {
            successCallback = success;
            API.tumblrLoginWidget();
        },
        'get:facebook:albums': function(access_token, callback, nextUrl) {
            _API.getFacebookAlbums(access_token, callback, nextUrl);
        },
        'social:login:success': function(social_profile) {
            if (social_profile.source == 'twitter') {
                App.currentUser.set('twitter_status', {
                    is_connected: true,
                    message: ''
                });
            } else if (social_profile.source == 'tumblr') {
                App.currentUser.set('isConnectedToTumblr', true);
            } else if (social_profile.source == 'facebook') {
                App.currentUser.set('facebook_status', {
                    is_connected: true,
                    message: ''
                });
            } else if (social_profile.source == 'google') {
                App.currentUser.set('google_status', {
                    is_connected: true,
                    message: ''
                });
            }
            App.currentUser.fetch({ reset: true });
            API.trackAnalytics('login social platform', {
                category: "social platforms",
                moduleName: _this.moduleName,
                url: window.location.href,
                platform: social_profile.source,
                account_id: gon.current_account.id,
                parentURL: gon.parentURL,
                distinct_user_hash: gon.distinct_user_hash,
                fingerprint: gon.fingerprint
            });
            successCallback(social_profile);
            successCallback = null;
        },
        'photo:social:login:success': function(social_profile) {
            API.trackAnalytics('login social platform photos', {
                category: "social platforms",
                moduleName: _this.moduleName,
                url: window.location.href,
                platform: social_profile.source,
                account_id: gon.current_account.id,
                parentURL: gon.parentURL,
                distinct_user_hash: gon.distinct_user_hash,
                fingerprint: gon.fingerprint
            });
            successCallback(social_profile);
            successCallback = null;
        },
        'open:share:pinterest': function(model) {
            API.handlePinterestShare(model);
        },
        'open:share:twitter': function(model) {
            API.handleTwitterShare(model);
        },
        'open:share:facebook': function(model, to) {
            API.handleFacebookShare(model, to);
        },
        'open:share:tumblr': function(model) {
            API.handleTumblrShare(model);
        }
    });


});
